module.exports = __webpack_public_path__ + "public/images/world-history.f14a0a23e3c549b12c5f894e41c8d925.jpg";